import AttachmentModel from '../store/schema/AttachmentModel';
import TypeOfAttachment from '../store/schema/TypeOfAttachment';
import { SharingData } from 'owa-sharing-data';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

export default function createSharingDataFromReferenceAttachment(
    attachment: AttachmentModel,
    isDownSellSupported: boolean
): SharingData | null {
    // We should only create SharingData for reference attachments
    if (attachment.type !== TypeOfAttachment.Reference) {
        return null;
    }

    const attachmentModel: ReferenceAttachment = attachment.model;
    return {
        id: attachment.id,
        name: attachmentModel.Name,
        supportsDownsell: isDownSellSupported,
        currentPermissionLevel: attachmentModel.PermissionType,
        sharingInfo: attachment.info.sharingInfo,
        sharingRecipientsInfo: { recipientPermissionInfos: [] }, //  We do not support recipient based perm check for reference attachments yet
        sharingTipsIgnored: [], // We do not support ignore for reference attachments yet
        typeOfLink: 'referenceAttachment',
    };
}
